import React from "react";
import { RewriteHighlight } from "../../types";
import styles from "./RewrittenEmailBody.module.css";

interface RewrittenEmailBodyProps {
  paragraphs: RewriteHighlight[];
}

export default function RewrittenEmailBody({ paragraphs }: RewrittenEmailBodyProps) {
  return (
    <div className={styles.body}>
      {paragraphs.map((p, idx) => (
        <p
          key={idx}
          className={`${styles.paragraph} ${
            p.kind === "added" ? styles.added : styles.original
          }`}
        >
          {p.text}
        </p>
      ))}
    </div>
  );
}
